var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.buildMessage = void 0;

var _get = _interopRequireDefault(require("lodash/get"));

var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));

var _moment = _interopRequireDefault(require("moment"));

var _i18n = _interopRequireDefault(require("../../../i18n"));

var _MessageHelper = require("../../../utilities/MessageHelper");

var buildMessage = function buildMessage(matches, header, commentaries, status) {
  var match = (0, _get.default)(matches, '[0]');

  if (status === 'POSTPONED' || status === 'CANCELLED') {
    return (0, _i18n.default)('empty_message.CONFERENCETICKER_NO_MATCHES', {
      matchDate: (0, _moment.default)(match.scheduledStartTime).format('DD. MMMM YYYY')
    });
  }

  var emptyResultCallback = function emptyResultCallback() {
    return header && (0, _isEmpty.default)(commentaries) ? (0, _i18n.default)('empty_message.PRE_CONFERENCETICKER') : (0, _i18n.default)('empty_message.CONFERENCETICKER');
  };

  return (0, _MessageHelper.buildMatchDateMessage)(match, 'empty_message.PRE_CONFERENCETICKER_WITH_DATE', emptyResultCallback);
};

exports.buildMessage = buildMessage;